import {Action} from "@ngrx/store";
import {TOidcProviderType} from "../../models/security/authentication.interface";
import {IWorkflowAuthData} from "@retail-data-factory/rdf-angular-types-api";

export enum EAuthenticationActions {
  SetToken = '[Authentication] Set Access Token',
  DestroyToken = '[Authentication] Destroy Access Token',
  SetTokenSuccess = '[Authentication] Set Access Token Success',

  Authenticate = '[Authentication] Authenticate by login/password',
  AuthenticateByAccessToken = '[Authentication] Authenticate by OpenAm AccessToken',
  AuthenticateByOidc = '[Authentication] Authenticate by oidc (google, facebook etc)',
  AuthenticationSuccess = '[Authentication] Authentication Success',
  AuthenticationFailure = '[Authentication] Authentication Failure',

  Validate = '[Authentication] Validate Token',
  ValidationSuccess = '[Authentication] Validation Token Success',
  ValidationFailure = '[Authentication] Validation Token Failure',

  Logout = '[Authentication] Logout',
  LogoutSuccess = '[Authentication] Logout Success',
  LogoutFailure = '[Authentication] Logout Failure',

  ClearAuthStore = '[Authentication] Clear Auth Store',
  ClearAll = '[System] Clear All Stores',

  StartPostAuthenticationProcess = '[Authentication] StartPostAuthenticationProcess',
  ProgressPostAuthenticationProcess = '[Authentication] StartPostAuthenticationProcess',
  FinishPostAuthenticationProcess = '[Authentication] StartPostAuthenticationProcess',


  AuthenticateWorkflow = '[Authentication] Authenticate in workflow subsystem',
  AuthenticationWorkflowSuccess = '[Authentication] Authentication in workflow subsystem success',
  AuthenticationWorkflowFailure = '[Authentication] Authentication in workflow subsystem failure',

  ClearLoginPassword = '[Authentication] Clear login and password in store'

}

export class SetToken implements Action {
  public readonly type = EAuthenticationActions.SetToken;

  constructor(public payload: string) {
    console.log('Action SetToken - constructor');
  }
}

export class SetTokenSuccess implements Action {
  public readonly type = EAuthenticationActions.SetTokenSuccess;
}

export class DestroyToken implements Action {
  public readonly type = EAuthenticationActions.DestroyToken;
}

export class Authenticate implements Action {
  public readonly type = EAuthenticationActions.Authenticate;

  constructor(public payload: { login: string, password: string }) {
  }
}

export class AuthenticateByAccessToken implements Action {
  public readonly type = EAuthenticationActions.AuthenticateByAccessToken;

  constructor(public payload: { accessToken: string; workflowToken: string }) {
  }
}

export class AuthenticateByOidc implements Action {
  public readonly type = EAuthenticationActions.AuthenticateByOidc;

  constructor(public payload: { oidcToken: string, oidcProviderType: TOidcProviderType }) {
  }
}

export class AuthenticationSuccess implements Action {
  public readonly type = EAuthenticationActions.AuthenticationSuccess;

  constructor(public payload: { accessToken: string; workflowToken: string}) {
  }
}

export class AuthenticationFailure implements Action {
  public readonly type = EAuthenticationActions.AuthenticationFailure;
}

export class Validate implements Action {
  public readonly type = EAuthenticationActions.Validate;

  constructor(public payload: { accessToken: string }) {
  }
}

export class ValidationSuccess implements Action {
  public readonly type = EAuthenticationActions.ValidationSuccess;

}

export class ValidationFailure implements Action {
  public readonly type = EAuthenticationActions.ValidationFailure;

}

export class Logout implements Action {
  public readonly type = EAuthenticationActions.Logout;
}
export class LogoutSuccess implements Action {
  public readonly type = EAuthenticationActions.LogoutSuccess;
}
export class LogoutFailure implements Action {
  public readonly type = EAuthenticationActions.LogoutFailure;
}

export class ClearAuthStore implements Action {
  public readonly type = EAuthenticationActions.ClearAuthStore;
}

export class ClearAll implements Action {
  public readonly type = EAuthenticationActions.ClearAll;
}

export class StartPostAuthenticationProcess implements Action {
  public readonly type = EAuthenticationActions.StartPostAuthenticationProcess;

  constructor(public payload: { stages: number }) {
  }
}

export class ProgressPostAuthenticationProcess implements Action {
  public readonly type = EAuthenticationActions.ProgressPostAuthenticationProcess;
}

export class FinishPostAuthenticationProcess implements Action {
  public readonly type = EAuthenticationActions.FinishPostAuthenticationProcess;
}

export class AuthenticateWorkflow implements Action {
  public readonly type = EAuthenticationActions.AuthenticateWorkflow;
}
export class AuthenticationWorkflowSuccess implements Action {
  public readonly type = EAuthenticationActions.AuthenticationWorkflowSuccess;
  constructor(public payload: IWorkflowAuthData) {
  }

}
export class AuthenticationWorkflowFailure implements Action {
  public readonly type = EAuthenticationActions.AuthenticationWorkflowFailure;
}

export class ClearLoginPassword implements Action{
  public readonly type = EAuthenticationActions.ClearLoginPassword;
}


export type AuthenticationActions =
  SetToken |
  SetTokenSuccess |
  DestroyToken |

  Authenticate |
  AuthenticateByAccessToken |
  AuthenticateByOidc |
  AuthenticationSuccess |
  AuthenticationFailure |

  Validate |
  ValidationSuccess |
  ValidationFailure |

  Logout |
  LogoutSuccess |
  LogoutFailure |

  ClearAuthStore |
  ClearAll |
  ClearLoginPassword |


  StartPostAuthenticationProcess |
  ProgressPostAuthenticationProcess |
  FinishPostAuthenticationProcess |

  AuthenticateWorkflow |
  AuthenticationWorkflowSuccess |
  AuthenticationWorkflowFailure;


